import { ScrollArea } from '@/components/ui/scroll-area'
import { Badge } from '@/components/ui/badge'
import { TriageCard } from '@/components/evidence/TriageCard'
import type { StatusKey } from '@/components/evidence/statusConfig'
import type { AtomicBreakdownEntry } from '@/types/api'

interface ShareTriageViewProps {
  entries: AtomicBreakdownEntry[]
  selectedClaimIndex: number | null
  onSelectClaim: (claimIndex: number) => void
}

/**
 * Read-only Triage list for the public share view. Mirrors the in-app
 * ``TriageView`` (see ``components/evidence/TriageView.tsx``) but reads
 * from a frozen snapshot — no audit re-runs, no D4-removed citations
 * group, no eye/highlight toggles, no D12 restore. The shared
 * ``TriageCard`` primitive renders each row identically to the app.
 */
export function ShareTriageView({
  entries,
  selectedClaimIndex,
  onSelectClaim,
}: ShareTriageViewProps) {
  const claimCount = entries.length

  return (
    <ScrollArea className="flex-1 min-h-0">
      <div className="bg-muted p-3 flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h3 className="font-headline text-sm font-bold tracking-wide uppercase text-muted-foreground">
            Review Pipeline
          </h3>
          <Badge variant="secondary" className="text-xs">
            {claimCount} claim{claimCount !== 1 ? 's' : ''}
          </Badge>
        </div>

        {entries.map((entry, i) => (
          <TriageCard
            key={i}
            entry={entry}
            claimIndex={i}
            isSelected={selectedClaimIndex === i}
            effectiveStatus={(entry.status ?? 'unverified') as StatusKey}
            isRemoved={false}
            onSelect={() => onSelectClaim(i)}
          />
        ))}

        <div className="pb-2" />
      </div>
    </ScrollArea>
  )
}
